import { render, staticRenderFns } from "./favoritos.vue?vue&type=template&id=7fd15b76&scoped=true&"
import script from "./favoritos.vue?vue&type=script&lang=js&"
export * from "./favoritos.vue?vue&type=script&lang=js&"
import style0 from "./favoritos.vue?vue&type=style&index=0&id=7fd15b76&lang=scss&scoped=true&"
import style1 from "./favoritos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd15b76",
  null
  
)

export default component.exports